import { GetListParams } from 'react-admin';
import { CustomDataProvider, registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { DepositFilters, listDeposits } from '../../../services/xbitRelayService';
import { DEFAULT_DEPOSITS_PROVIDER } from './constants';

const resourceName = 'xbit-relay/deposits';

const pickFilter = (filter: any): DepositFilters => {
  if (!filter) return {};
  const out: DepositFilters = {};
  if (filter.status) out.status = filter.status;
  if (filter.toAddress) out.toAddress = filter.toAddress;
  if (filter.chainId !== undefined && filter.chainId !== '' && filter.chainId !== null) {
    out.chainId = Number(filter.chainId);
  }
  if (filter.token) out.token = filter.token;
  if (filter.userId) out.userId = filter.userId;
  if (filter.userAddress) out.userAddress = filter.userAddress;
  if (filter.txHash) out.txHash = filter.txHash;
  if (filter.timeFrom) out.timeFrom = Number(filter.timeFrom);
  if (filter.timeTo) out.timeTo = Number(filter.timeTo);
  return out;
};

export const xbitRelayDepositsDataProvider: CustomDataProvider = {
  async getList(_resource: string, params: GetListParams): Promise<any> {
    const { page = 1, perPage = 20 } = params.pagination || {};
    const filter = params.filter || {};
    const provider = filter.provider || DEFAULT_DEPOSITS_PROVIDER;

    const response = await listDeposits({
      ...pickFilter(filter),
      provider,
      page,
      pageSize: perPage,
    });

    const { items = [], total } = response.data || ({} as any);
    return {
      data: items.map((item) => ({ ...item, id: item.id })),
      total: Number(total) || 0,
    };
  },
};

registerModuleDataProvider(resourceName, xbitRelayDepositsDataProvider);
